module.exports = __webpack_public_path__ + "static/media/18_B.94a7b638.png";